// src/api/axiosInstance.js
import axios from 'axios';
import { getToken, removeToken, isTokenExpired } from 'utils/auth';

// Use environment variable with fallback to localhost:3005
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://academy.innovatorsforge.com';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Trigger logout via custom event
const triggerLogout = () => {
  console.log('Triggering logout due to authentication error');
  const event = new CustomEvent('auth:logout', { detail: { redirect: true } });
  window.dispatchEvent(event);
};

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getToken();
    if (token) {
      if (isTokenExpired(token)) {
        console.warn('Token expired, triggering logout');
        removeToken();
        triggerLogout();
        return Promise.reject(new Error('Token expired'));
      }
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request interceptor error:', error.message);
    return Promise.reject(error);
  }
);

// Response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401) {
        console.warn('Received 401 Unauthorized, triggering logout');
        removeToken();
        triggerLogout();
        return Promise.reject(new Error('Unauthorized: Please log in again'));
      }
      if (status === 403) {
        console.error('Forbidden: Insufficient permissions');
        // Optionally handle 403 (e.g., notify user or redirect)
      }
    }
    console.error('Response error:', error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;